<template>
  <div class="dialog-container wt-dialog-container">
    <div>

      <div class="user-info-card">
        <div class="user-detail">
          <div class="user-detail-top">
            <div class="user-detail-photo">
                <el-image
                  style="width: 50px; height: 50px border-radius: 50%;"
                  :src="$wtUtil.checkUserPhoto(detailFormData.headPortrait) ? detailFormData.headPortrait : imgUrl + detailFormData.headPortrait"
                  :z-index="999"
                  fit="cover"
                  :preview-src-list="$wtUtil.checkUserPhoto(detailFormData.headPortrait) ? [detailFormData.headPortrait] : [imgUrl + detailFormData.headPortrait]"></el-image>
            </div>
            <div class="user-detail-username">{{ $wtUtil.transUserName(detailFormData.name) }}</div>
            <div class="user-detail-level" v-if="detailFormData.userType === 2">大客户</div>
          </div>
          <div class="user-detail-bottom">
            <div class="user-detail-item"><span class="user-detail-label">用户姓名：</span><span class="user-detail-value">{{ $wtUtil.transUserName(detailFormData.name) }}</span></div>
            <div class="user-detail-item"><span class="user-detail-label">余额：</span><span class="user-detail-value">{{ $wtUtil.transMoney(detailFormData.residueMoney) }}</span></div>
            <div class="user-detail-item"><span class="user-detail-label">注册时间：</span><span class="user-detail-value">{{ detailFormData.createTime }}</span></div>
          </div>
          <el-tabs v-model="activeTabName">
            <el-tab-pane label="基本信息" name="first"></el-tab-pane>
            <el-tab-pane label="垃圾投递" name="second"></el-tab-pane>
          </el-tabs>
        </div>
      </div>
      <!-- tab内容 -->
      <div class="tab-info-card">
        <div v-if="activeTabName === 'first'">
          <div class="tab-info-title">基本资料</div>
          <div class="tab-info-content tab-base">
            <div class="tab-base-item">
              <span class="tab-base-label">用户姓名：</span>
              <span class="tab-base-value">{{ detailFormData.name }}</span>
            </div>
            <div class="tab-base-item">
              <span class="tab-base-label">手机号码：</span>
              <span class="tab-base-value">{{ detailFormData.phone }}</span>
            </div>
            <div class="tab-base-item">
              <span class="tab-base-label">性别：</span>
              <span class="tab-base-value" v-if="detailFormData.gender === 0">保密</span>
              <span class="tab-base-value" v-if="detailFormData.gender === 1">男</span>
              <span class="tab-base-value" v-if="detailFormData.gender === 2">女</span>
            </div>
<!--            <div class="tab-base-item">
              <span class="tab-base-label">省市县：</span>
              <span class="tab-base-value"></span>
            </div> -->
            <div class="tab-base-item">
              <span class="tab-base-label">社区：</span>
              <span class="tab-base-value">{{ detailFormData.communityName }}</span>
            </div>
            <div class="tab-base-item">
              <span class="tab-base-label">门牌号：</span>
              <span class="tab-base-value">{{ detailFormData.doorplate }}</span>
            </div>
            <div class="tab-base-item">
              <span class="tab-base-label">注册时间：</span>
              <span class="tab-base-value">{{ detailFormData.createTime }}</span>
            </div>
          </div>
        </div>
        <div v-if="activeTabName === 'second'">
          <div class="tab-info-title">垃圾投递 <span class="tab-info-tip">投递次数：{{secondForm.formResult.garbageTotalCount}}次     总重量：{{$wtUtil.transWeight(secondForm.formResult.garbageTotalWeight)}}kg</span></div>
          <div class="tab-info-content">
            <wt-form-table :form.sync="secondForm" >
              <wt-form-table-list slot="wtFormTableList" :form.sync="secondForm">
                <template slot="garbageWeight" slot-scope="data">
                  <span>{{ $wtUtil.transWeight(data.row.garbageWeight) }}</span>
                </template>
                <template slot="garbagePrice" slot-scope="data">
                  <span>{{ $wtUtil.transMoney(data.row.garbagePrice) }}</span>
                </template>
                <template slot="garbageTotalPrice" slot-scope="data">
                  <span>{{ $wtUtil.transMoney(data.row.garbageTotalPrice) }}</span>
                </template>
              </wt-form-table-list>
            </wt-form-table>
          </div>
        </div>
      </div>
      <div class="tab-info-card" v-if="activeTabName === 'first'">
        <div>
          <div class="tab-info-title">大客户信息</div>
          <div class="tab-info-content tab-base">
            <div class="tab-base-item">
              <span class="tab-base-label">银行卡号：</span>
              <span class="tab-base-value">{{ detailFormData.bankCar }}</span>
            </div>
            <div class="tab-base-item">
              <span class="tab-base-label">开户行：</span>
              <span class="tab-base-value">{{ detailFormData.bankName }}</span>
            </div>
            <div class="tab-base-item">
              <span class="tab-base-label">身份证照片：</span>
              <el-image v-if="detailFormData.idCard"
                    style="width: 100px; height: 100px;"
                    :preview-src-list="[imgUrl + detailFormData.idCard]"
                    :src="imgUrl + detailFormData.idCard"
                    fit="cover"></el-image>
            </div>
            <div class="tab-base-item">
              <span class="tab-base-label">营业执照：</span>
              <el-image v-if="detailFormData.businessLicense"
                    style="width: 100px; height: 100px;"
                    :preview-src-list="[imgUrl + detailFormData.businessLicense]"
                    :src="imgUrl + detailFormData.businessLicense"
                    fit="cover"></el-image>
            </div>
            <div class="tab-base-item">
              <span class="tab-base-label">其他：</span>
              <span class="tab-base-value">{{ detailFormData.otherInfo }}</span>
            </div>
          </div>
        </div>
      </div>
      <wt-detail-form-buttons :detail-form-buttons.sync="detailFormButtons" @on-detail-button-action="onDetailButtonAction"></wt-detail-form-buttons>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'CustomerInfoView',
  props: ['component-type'],
  isAutoComponent: true,
  data() {
    return {
      imgUrl: window.wtConst.FILE_SERVER_URL,
      formCode: 'MODULES_USERMESSAGE',
      isSubmitLoading: false,
      formUpdateUrl: '/modules/userMessage/userMessageUpdate',
      formAddUrl: '/modules/userMessage/userMessageAdd',
      detailFormButtons: {
        title: '用户详情',
        elements: [{ name: '创建', key: 'ADD', action: 'ADD', hidden: this.componentType !== 'add' },
          { name: '保存', key: 'EDIT', action: 'EDIT', hidden: this.componentType !== 'edit' },
          { name: '返回', key: 'CLOSE', action: 'CLOSE' }]
      },
      activeTabName: 'first',
      secondForm: {
        isFormLoading: false,
        formComponent: {
          list: { type: 'default', value: '/modules/userDeliveryGarbage/userDeliveryGarbageListByUserId' }
        },
        formInputsData: [{ name: '客户类型', key: 'id', value: 1, type: 'customAll' }],
        formButtonsData: [],
        formTableData: [
          { name: '垃圾', key: 'garbageName', type: 'text' },
          { name: '投递总量(kg)', key: 'garbageWeight', type: 'custom' },
          { name: '单价(元)', key: 'garbagePrice', type: 'custom' },
          { name: '价值(元)', key: 'garbageTotalPrice', type: 'custom' },
          { name: '交付时间', key: 'createTime', type: 'text', sortable: 'custom' },
          { name: '获得金额(元)', key: 'garbageTotalPrice', type: 'custom' }],
        formTableButtonsData: [],
        formResult: {},
        pageData: { currentPage: 0, pageSize: 20, sortName: '', sortOrder: '' },
        formTableProp: { selection: false, index: true, buttonHidden: true, searchButtonHidden: true }
      }
    }
  },
  created() {
    this.$store.dispatch('appendBreadcrumb', { meta: { title: '用户详情' }})
    this.secondForm.formInputsData[0].value = this.customerId
  },
  methods: {
    /*  ------------------------- 按钮  -------------------------  */
    onDetailButtonAction(item) {
      if (item.action === 'CLOSE') {
        this.$emit('on-dialog-action', 'close')
        this.$store.dispatch('removeBreadcrumb')
      }
    },
    /*  ------------------------- 网络请求  -------------------------  */
    onWtDialogClose() {
      this.$emit('on-dialog-action', 'close')
    }
  },
  computed: {
    ...mapState({
      detailFormData: state => state.userWechat.userWechatDetailData,
      customerId: state => state.userWechat.customerId
    })
  }
}
</script>

<style lang="scss" scoped>
.user-info-card {
  .user-detail {
    background: #fff;
    .user-detail-top {
      display: flex;
      align-items: center;
      padding: 20px;
    }
    .user-detail-photo {
      width: 48px;
      height: 48px;
      // border: 1px solid #666;
      border-radius: 50%;
      margin-right: 16px;
      overflow: hidden;
      img {
        width: 48px;
        height: 48px;
      }
    }
    .user-detail-username {
      font-size: 20px;
      font-weight: 500;
      line-height: 20px;
      color: #333;
      margin-right: 16px;
    }
    .user-detail-level {
      padding: 2px 8px;
      font-size: 12px;
      line-height: 14px;
      border: 1px solid rgba(204, 204, 204, 1);
      color: #666;
    }
    .user-detail-bottom {
      display: flex;
      align-items: center;

    }
    .user-detail-label {
      margin-left: 84px;
      color: #989898;
    }
    .user-detail-value {
      color: #666666;
    }
  }
}
.tab-info-card {
  margin-top: 20px;
  background: #fff;
  .tab-info-title {
    padding: 20px;
    border-bottom: 1px solid rgba(228, 228, 228, 1);
    font-size: 16px;
    font-weight: 600;
    color: #444;
    .tab-info-tip {
      padding-left: 20px;
      color: #7F7F7F;
      font-size: 14px;
      font-weight: 200;
    }
  }
  .tab-base {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    .tab-base-item {
      display: flex;
      align-items: center;
      width: 400px;
      margin-bottom: 20px;
    }
    .tab-base-label {
      width: 100px;
      text-align: right;
      color: #989898;
    }
    .tab-base-value {
      color: #666666;
    }
    .tab-base-img {
      width: 80px;
      height: 80px;
    }
  }
  .tab-info-content {
    padding: 20px;
  }
}
</style>
<style lang="scss">
.user-info-card {
  .el-tabs__header {
    margin-bottom: 0;
    .el-tabs__item.is-active {
      color: #108ee9;
    }
  }
  .el-tabs--top .el-tabs__item.is-top:nth-child(2) {
    padding-left: 20px;
  }
  .el-tabs {
    margin-top: 20px;
  }
}
</style>
